import { useEffect, useRef, useState } from 'react';
import { getPusher } from './pusherSingleton';
import axios from 'axios';

const usePusherChat = (chatId, currentUserId, onNewMessage) => {
    const [typingUsers, setTypingUsers] = useState([]);
    const timersRef       = useRef({});
    const typingDebounce  = useRef(null);
    const onNewMessageRef = useRef(onNewMessage);
    useEffect(() => { onNewMessageRef.current = onNewMessage; }, [onNewMessage]);

    useEffect(() => {
        if (!chatId || !getPusher()) return;

        const pusher  = getPusher();
        const channel = pusher.subscribe(`chat.${chatId}`);

        channel.bind('typing', (data) => {
            if (data.user_id == currentUserId) return;
            setTypingUsers(prev => {
                if (prev.find(u => u.user_id == data.user_id)) return prev;
                return [...prev, data];
            });
            if (timersRef.current[data.user_id]) clearTimeout(timersRef.current[data.user_id]);
            timersRef.current[data.user_id] = setTimeout(() => {
                setTypingUsers(prev => prev.filter(u => u.user_id != data.user_id));
            }, 3000);
        });

        channel.bind('new-message', (data) => {
            if (onNewMessageRef.current) onNewMessageRef.current(data.message);
        });

        return () => {
            pusher.unsubscribe(`chat.${chatId}`);
            Object.values(timersRef.current).forEach(clearTimeout);
        };
    }, [chatId, currentUserId]);

    const broadcastTyping = (userName) => {
        if (!currentUserId || !chatId) return;
        if (typingDebounce.current) return;
        axios.post('https://buzzinguniverse.com/backend/api/chat-typing', {
            chat_id: chatId,
            user_id: currentUserId,
            user_name: userName,
        }).catch(() => {});
        typingDebounce.current = setTimeout(() => { typingDebounce.current = null; }, 2000);
    };

    return { typingUsers, broadcastTyping };
};

export default usePusherChat;
